// extracted by mini-css-extract-plugin
export default {"userAgreement":"UserAgreement_userAgreement__QK4x","userAgreementTitle":"UserAgreement_userAgreementTitle_Gdbgp","userAgreementIframe":"UserAgreement_userAgreementIframe_MVpDS"};